import { Col, Form, Row, Select } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { useAppSelector } from "../../../../../../hooks/use-app-selector.ts"
import { PROJECT_ENTITY_CATEGORIES } from "../../../../ProjectViewPage/constants/project-entity-category.ts"

interface ProjectTypeCategoryFieldsProps {
  assignedTypeIds?: string[]
  typeNames: Record<string, string>
}

export function ProjectTypeCategoryFields({
  assignedTypeIds = [],
  typeNames
}: ProjectTypeCategoryFieldsProps) {
  const { t } = useTranslation()
  const form = Form.useFormInstance<{ project_type?: string[] | null }>()
  const selectedIds = Form.useWatch("project_type", form)
  const categories = useAppSelector(
    (state) => state?.projects?.filterOptions?.category || []
  )

  const addedIds = (selectedIds || []).filter(
    (id) => !assignedTypeIds.includes(id)
  )

  if (!addedIds.length) return null

  return (
    <Row gutter={16}>
      {addedIds.map((id) => (
        <Col xs={24} sm={12} key={id}>
          <Form.Item
            label={t("projectTypeCategory.label", {
              typeName: typeNames?.[id] || t("projectTypeCategory.newType")
            })}
            name={["project_type_categories", id]}
            initialValue={PROJECT_ENTITY_CATEGORIES.STANDARD}
            rules={[
              { required: true, message: t("projectTypeCategory.required") }
            ]}
          >
            <Select
              className={"w-full"}
              placeholder={t("projectTypeCategory.placeholder")}
              options={categories}
            />
          </Form.Item>
        </Col>
      ))}
    </Row>
  )
}
